import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NavigationService } from '@cpd-app/core-module/services';
import { BugReportInput, FeedbackInput } from '@cpd-app/generated';
import { SystemStatusFacade } from '@cpd-app/state/system-status';
import { take } from 'rxjs';

@Component({
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.scss']
})
export class FeedbackDialogComponent implements OnInit {
  public isSubmited = false;
  public publishedSystemReports$ =
    this.systemStatusFacade.publishedSystemReports$;
  public alert: { title: string; message?: string };

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { isIssue: boolean },
    public dialogRef: MatDialogRef<FeedbackDialogComponent>,
    private systemStatusFacade: SystemStatusFacade,
    private navigationService: NavigationService
  ) {
    this.dialogRef.addPanelClass('feedback-dialog');
  }

  public ngOnInit(): void {
    this.systemStatusFacade.getSystemReports();
  }

  public onFeedback(input: FeedbackInput): void {
    this.systemStatusFacade.feedback(input);

    this.systemStatusFacade.feedbackSuccess$.pipe(take(1)).subscribe(() => {
      this.alert = { title: 'Thank you!' };
      this.isSubmited = true;
    });
  }

  public onReport(input: BugReportInput): void {
    this.systemStatusFacade.reportBug(input);

    this.systemStatusFacade.reportBugSuccess$.pipe(take(1)).subscribe(() => {
      this.alert = {
        title: 'Thank you, we have received your report!',
        message:
          'If we have updates on this issue we will be reporting this on the'
      };
      this.isSubmited = true;
    });
  }

  public goToStatusPage(): void {
    this.dialogRef.close();
    this.navigationService.goToSystemStatus();
  }
}
